<template>
    <div class="app-logout">
      <a v-on:click="logOut()"><slot name="lblButton">Logout</slot></a>
    </div>
</template>

<script>

import logout from '../../../../../mixins/logout'
import extraData from '../../../../../mixins/extraData'

export default {
  name: 'LogOut',
  mixins: [
    logout,
    extraData()
  ]
}
</script>
